import React from 'react';
import { Paragraph, SpacingBox, SyncIcon } from '../Components';
import { getTranslateByScope } from '../i18n';

const translate = getTranslateByScope('app.preloadImageText');

export const PreloadImageText = () => (
  <div
    style={{
      position: 'fixed',
      right: 16,
      display: 'flex',
      flexDirection: 'row',
      bottom: 16,
    }}>
    <SpacingBox marginRight="md">
      <SyncIcon />
    </SpacingBox>
    <Paragraph>{translate('text')}</Paragraph>
  </div>
);
